export const CHAIN_ID = {
  BASE: 8453,
} as const;
